var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerDarkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spinner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spinners",
    transform: "translate(-153.000000, -99.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(153.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#EAEAEA",
    opacity: 0.5,
    cx: 11,
    cy: 11,
    r: 9.77777778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,1.22222222 C5.59988245,1.22222222 1.22222222,5.59988245 1.22222222,11 C1.22222222,16.4001176 5.59988245,20.7777778 11,20.7777778 C16.4001176,20.7777778 20.7777778,16.4001176 20.7777778,11",
    id: "Path",
    stroke: "#FFFFFF",
    opacity: 0.8,
    strokeLinecap: "round",
    transform: "translate(11.000000, 11.000000) rotate(-87.000000) translate(-11.000000, -11.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerDarkBg);
export default __webpack_public_path__ + "static/media/spinner-dark-bg.37321df116fac8c6972855b47829b084.svg";
export { ForwardRef as ReactComponent };